var React = require('react');

function NavIconsGlobals (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m12 21.68a9.68 9.68 0 1 1 9.68-9.68 9.69 9.69 0 0 1 -9.68 9.68zm0-18.32a8.64 8.64 0 1 0 8.64 8.64 8.64 8.64 0 0 0 -8.64-8.64z","key":0}),React.createElement("path",{"d":"m2.84 11.43h18.33v1.04h-18.33z","key":1}),React.createElement("path",{"d":"m4.04 16.01h15.93v1.04h-15.93z","key":2}),React.createElement("path",{"d":"m4.09 6.85h15.81v1.04h-15.81z","key":3}),React.createElement("path",{"d":"m12 21.68c-3.1 0-5.1-7.19-5.1-9.68s2-9.68 5.1-9.68v1c-2 0-4.06 6-4.06 8.64s2.06 8.68 4.06 8.68z","key":4}),React.createElement("path",{"d":"m11.48 2.84h1.04v18.33h-1.04z","key":5}),React.createElement("path",{"d":"m12 21.68v-1c2 0 4.06-6 4.06-8.64s-2.06-8.68-4.06-8.68v-1c3.1 0 5.1 7.19 5.1 9.68s-2 9.64-5.1 9.64z","key":6})]);
}

NavIconsGlobals.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsGlobals;

NavIconsGlobals.default = NavIconsGlobals;
